module.exports = "/packs/course-small-ui-ux-46e0ba15ff4782b820ad99e4dcdad211.png";